import React, { useMemo } from "react";
import DataTable from "../../_Components/DataTable";
import SplitNumber from "../../_Components/SplitNumber";
import { Link } from "react-router-dom";
function DataGrid({ data }) {
  const columns = useMemo(() => [
    {
      accessor: "id",
      Header: "شماره بلیط",
      minWidth: 80,
    },
    {
      accessor: "basketId",
      Header: "شماره سفارش",
      minWidth: 100,
    },
    {
      accessor: "basketUserFullName",
      Header: "نام ونام خانوادگی",
      minWidth: "150px",
    },
    {
      accessor: "basketItemAmusementServiceName",
      Header: "تفریح",
      minWidth: "180px",
    },
    {
      accessor: "basketItemAmusementServiceReserveItemGroupTitle",
      Header: "آیتم",
      minWidth: "250px",
      Cell: ({ row }) => (
        <div>
          {row.original.basketItemAmusementServiceReserveItemTitle +
            " - " +
            row.original.basketItemAmusementServiceReserveItemGroupTitle}
        </div>
      ),
    },
    {
      accessor: "basketItemOriginalPrice",
      Header: "نرخ مصوب",
      minWidth: "100px",
      Cell: ({ row }) => (
        <div style={{ textDecoration: "line-through" }}>
          <SplitNumber number={row.original.basketItemOriginalPrice} />
        </div>
      ),
    },

    {
      accessor: "basketItemSalePrice",
      Header: "نرخ فروش",
      minWidth: "100px",
      Cell: ({ row }) => (
        <div>
          <SplitNumber number={row.original.basketItemSalePrice} />
        </div>
      ),
      Footer: (info) => {
        // Only calculate total profit if rows change
        const total = React.useMemo(
          () => info.rows.reduce((sum, row) => row.original.basketItemSalePrice + sum, 0),
          [info.rows],
        );
        return (
          <div className="text-center success">
            {" "}
            <SplitNumber number={total} />
          </div>
        );
      },
    },
    // {
    //   accessor: "basketItemPromoCodeDiscountPrice",
    //   Header: " کد تخفیف",
    //   minWidth: "100px",
    //   Cell: ({ row }) => (
    //     <div>
    //       <SplitNumber number={row.original.basketItemPromoCodeDiscountPrice} />
    //     </div>
    //   ),
    // },
    // {
    //   accessor: "amount",
    //   Header: "قیمت نهایی",
    //   minWidth: "100px",
    //   Cell: ({ row }) => (
    //     <div>
    //       <SplitNumber number={row.original.amount} />
    //     </div>
    //   ),
    //   Footer: (info) => {
    //     // Only calculate total profit if rows change
    //     const total = React.useMemo(() => info.rows.reduce((sum, row) => row.original.amount + sum, 0), [info.rows]);
    //     return (
    //       <div className="text-center success">
    //         {" "}
    //         <SplitNumber number={total} />
    //       </div>
    //     );
    //   },
    // },
    {
      accessor: "payToWarrantyAmount",
      Header: "تسویه",
      minWidth: "100px",
      maxWidth: "100px",
      Cell: ({ row }) => (
        <div className="">
          <SplitNumber number={row.original.payToWarrantyAmount - row.original.receiveOfWarrantyAmount} />
        </div>
      ),
    },
    // {
    //   accessor: "receiveOfWarrantyAmount",
    //   Header: "مبلغ بازگشتی به تفریحان",
    //   minWidth: "100px",
    //   maxWidth: "100px",
    //   Cell: ({ row }) => (
    //     <div className="">
    //       <SplitNumber number={row.original.receiveOfWarrantyAmount} />
    //     </div>
    //   ),
    // },
    // {
    //   accessor: "agentCommisionPrice",
    //   Header: "کمیسیون نماینده",
    //   minWidth: "100px",
    //   Cell: ({ row }) => (
    //     <div className="">
    //       <SplitNumber number={row.original.agentCommisionPrice} />
    //     </div>
    //   ),
    //   Footer: (info) => {
    //     // Only calculate total profit if rows change
    //     const total = React.useMemo(
    //       () => info.rows.reduce((sum, row) => row.original.agentCommisionPrice + sum, 0),
    //       [info.rows],
    //     );
    //     return (
    //       <div className="text-center success">
    //         {" "}
    //         <SplitNumber number={total} />
    //       </div>
    //     );
    //   },
    // },
    // {
    //   accessor: "strAgentCommissionSettlementStatus",
    //   Header: "وضعیت پرداخت کمیسیون نماینده",
    //   minWidth: "150px",
    // },
    // {
    //   accessor: "profit",
    //   Header: "سود ",
    //   minWidth: "100px",
    //   maxWidth: "100px",
    //   Cell: ({ row }) =>
    //     row.original.profit >= 0 ? (
    //       <div className="">
    //         <SplitNumber number={row.original.profit} />
    //       </div>
    //     ) : (
    //       <div className="text-danger">
    //         <SplitNumber number={row.original.profit} />
    //       </div>
    //     ),
    //   Footer: (info) => {
    //     // Only calculate total profit if rows change
    //     const total = React.useMemo(() => info.rows.reduce((sum, row) => row.original.profit + sum, 0), [info.rows]);
    //     return (
    //       <div className="text-center success">
    //         {" "}
    //         <SplitNumber number={total} />
    //       </div>
    //     );
    //   },
    // },
    {
      accessor: "currentStatus",
      Header: "وضعیت",
      align: "center",
      minWidth: 100,
      Cell: ({ row }) => (
        <div
          className={` rounded-pill px-2 py-1 d-flex justify-content-center ${
            row.original.currentStatus === "رهاسازی" ||
            row.original.currentStatus === "جدید"
              ? "bg-light-primary text-primary"
              : row.original.currentStatus === "در_حال_پیگیری"
                ? "bg-light-info text-info"
                : row.original.currentStatus === "انجام_شده"
                  ? "bg-light-success text-success"
                  : row.original.currentStatus === "انجام_نشده"
                    ? "bg-light-danger text-danger"
                    : ""
          }`}
        >
          {row.original.currentStatus === "رهاسازی"
            ? "جدید"
            : row.original.currentStatus}
        </div>
      ),
    },
    {
      accessor: "cancelStatus",
      Header: "وضعیت کنسلی",
      align: "center",
      minWidth: 100,
      Cell: ({ row }) => (
        <div
          className={` rounded-pill px-2 py-1 d-flex justify-content-center ${
            row.original.cancelStatus === "درخواست_کنسلی"
              ? "bg-light-primary text-primary"
              : row.original.cancelStatus === "پیگیری_کنسلی"
                ? "bg-light-info text-info"
                : row.original.cancelStatus === "کنسل_شد"
                  ? "bg-light-danger text-danger"
                  : row.original.cancelStatus === "رد_درخواست_کنسلی"
                    ? "bg-light-warning text-warning"
                    : ""
          }`}
        >
          {row.original.cancelStatus === "جدید" ||
          row.original.cancelStatus === "رهاسازی"
            ? "-"
            : row.original.cancelStatus}
        </div>
      ),
    },
    {
      accessor: "basketItemCheckInDate",
      Header: "تاریخ استفاده",
      minWidth: "100px",
    },
    // {
    //   accessor: "createdPersianTime",
    //   Header: "تاریخ ایجاد",
    //   minWidth: "90px",
    //   maxWidth: "90px",
    // },
    // {
    //     Header: 'عملیات',
    //     accessor: '',
    //     minWidth: 150,
    //     align: "center",
    //     Cell: ({ row }) => (
    //         <div className="text-center">

    //             {/* ویرایش */}
    //             <Link className="btn btn-light-primary btn-sm mr-2 btn-icon" to={`/createOrEditService/${row.original.id}`}>
    //                 <i className='far fa-edit text-small'></i>
    //             </Link>
    //         </div>
    //     )
    // }
  ]);

  const config = {
    page_size: 10,
    length_menu: [10, 50, 100],
    show_filter: false,
    show_pagination: true,
    pagination: "advance",
    show_footer: true,
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  };
  return (
    <div>
      <DataTable config={config} columns={columns} data={data} />
    </div>
  );
}

export default DataGrid;
